/**
 * Collection cards slider — arrow buttons, and nothing else.
 *
 * The strip already scrolls and snaps on its own. This nudges it one card per
 * click and works out whether the buttons deserve to be on screen at all. The
 * CSS keeps them hidden until this file says the strip overflows, so with JS
 * off the row is still a plain scrollable strip.
 *
 * RTL: browsers report scrollLeft as negative in an RTL scroller, so the sign
 * is flipped there and the position is read as an absolute value.
 */
(function () {
  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    var strip = root.querySelector('[data-ccs-strip]');
    var prev = root.querySelector('[data-ccs-prev]');
    var next = root.querySelector('[data-ccs-next]');
    if (!strip || !prev || !next || root.ccsReady) return;
    root.ccsReady = true;

    function go(sign) {
      var style = getComputedStyle(strip);
      var card = strip.firstElementChild;
      var step =
        (card ? card.getBoundingClientRect().width : strip.clientWidth * 0.8) +
        (parseFloat(style.columnGap) || 0);
      if (style.direction === 'rtl') sign = -sign;
      strip.scrollBy({ left: sign * Math.round(step), behavior: reduced ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    var frame = null;
    function update() {
      frame = null;
      var max = strip.scrollWidth - strip.clientWidth;
      root.classList.toggle('ccs--has-arrows', max >= 2);
      var pos = Math.abs(strip.scrollLeft);
      prev.disabled = pos <= 1;
      next.disabled = pos >= max - 1;
    }

    function schedule() {
      if (frame === null) frame = requestAnimationFrame(update);
    }

    strip.addEventListener('scroll', schedule, { passive: true });

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(schedule);
      ro.observe(strip);
      // The section is content-visibility: auto, so cards have no size until it
      // nears the viewport. Watching one card catches the moment it gets one.
      if (strip.firstElementChild) ro.observe(strip.firstElementChild);
    } else {
      window.addEventListener('resize', schedule, { passive: true });
    }

    update();
  }

  function boot(scope) {
    var nodes = (scope || document).querySelectorAll('[data-ccs]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
